import CardContact from './CardContact';

export default CardContact;
